import { render, staticRenderFns } from "./Shareandprintsettings.vue?vue&type=template&id=0f594a5c&scoped=true&"
import script from "./Shareandprintsettings.vue?vue&type=script&lang=js&"
export * from "./Shareandprintsettings.vue?vue&type=script&lang=js&"
import style0 from "./Shareandprintsettings.vue?vue&type=style&index=0&id=0f594a5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f594a5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1209661745/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f594a5c')) {
      api.createRecord('0f594a5c', component.options)
    } else {
      api.reload('0f594a5c', component.options)
    }
    module.hot.accept("./Shareandprintsettings.vue?vue&type=template&id=0f594a5c&scoped=true&", function () {
      api.rerender('0f594a5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Settings/Shareandprintsettings.vue"
export default component.exports